// @ts-nocheck
/**
 * chat.js — Orchestrator for the AI Florist storefront chat.
 *
 * Load order (all defer):
 *   1. chat-fetch.js
 *   2. chat-identity.js
 *   3. chat-render.js
 *   4. chat-history.js
 *   5. chat-media.js
 *   6. chat-send.js
 *   7. rich-text.js
 *   8. chat-stream.js
 *   9. chat-order-form.js
 *  10. chat-wedding-form.js
 *  11. chat-flower-lib.js
 *  12. chat-suggest-lib.js
 *  13. chat-autosuggest.js
 *  14. chat-locale.js
 *  15. chat-attribution.js
 *  16. chat-shell.js
 *  17. chat-events.js
 *  18. chat-controller.js
 *  19. chat.js  ← runs last, wires everything together
 */
(function () {
  'use strict';

  var AF = window.AIFlorist;
  var debug = (AF && AF.debug) || { log: function () {}, warn: function () {}, error: function () {} };
  if (!AF || !AF.fetch || !AF.identity || !AF.render || !AF.history || !AF.media || !AF.send || !AF.orderForm || !AF.weddingForm || !AF.locale || !AF.attribution || !AF.shell || !AF.events || !AF.controller || !AF.reply) {
    debug.error('[AI Florist] Missing dependencies. Ensure chat-*.js files load before chat.js.');
    return;
  }

  var apiFetch = AF.fetch;
  var stream = AF.stream || null;
  var identity = AF.identity;
  var render = AF.render;
  var history = AF.history;
  var media = AF.media;
  var sender = AF.send;
  var orderForm = AF.orderForm;
  var weddingForm = AF.weddingForm;
  var analytics = AF.analytics || null;
  var flowerLib = AF.flowerLib || null;
  var localeApi = AF.locale;
  var attributionApi = AF.attribution;
  var shellApi = AF.shell;
  var eventsApi = AF.events;
  var controllerApi = AF.controller;
  var replyApi = AF.reply;
  var marketing = AF.marketing || null;
  var autosuggest = AF.autosuggest || null;

  var root = document.getElementById('aiflorist-chat-root');
  if (!root) return;

  var LOCAL_WORKER_URL = 'http://localhost:8795';
  var isLocalDev = ['127.0.0.1', 'localhost'].indexOf(window.location.hostname) !== -1;
  var WORKER_URL = isLocalDev ? LOCAL_WORKER_URL : (root.dataset.workerUrl || '');
  var localeContext = localeApi.resolveContext(root);
  var localizedCopy = localeApi.getChatCopy(localeContext.language);
  var configuredWelcome = root.dataset.welcomeMessage || '';
  var WELCOME =
    (localeContext.language === 'en' && configuredWelcome)
      ? configuredWelcome
      : localizedCopy.welcome;
  var PRIVACY_URL = root.dataset.privacyUrl || '';
  var LOGO_URL = root.dataset.logoUrl || '/assets/aifloristlogo-transparent.png';
  var DEFAULT_TITLE = localizedCopy.title;
  var uiChrome = localeApi.getChromeCopy(localeContext.language);
  var checkoutMode = String(root.dataset.checkoutMode || 'direct').toLowerCase();
  // Force Add-to-Order mode as the canonical storefront flow.
  var addToOrderEnabled = true;
  window.AIFlorist.checkoutMode = checkoutMode;
  window.AIFlorist.addToOrderEnabled = addToOrderEnabled;

  var CID_KEY = 'aiflorist_cid';
  var conversationId = localStorage.getItem(CID_KEY);
  var isLoading = false;
  var customerIdentity = identity.build(root);
  var chatAttribution = captureAttributionBundle();

  var ui = shellApi.build(root, {
    uiChrome: uiChrome,
    logoUrl: LOGO_URL,
    defaultTitle: DEFAULT_TITLE,
  });
  var messagesEl = ui.messagesEl;
  var formEl = ui.formEl;
  var inputEl = ui.inputEl;
  var sendBtn = ui.sendBtn;
  var titleEl = ui.titleEl;
  var uploadBtn = ui.uploadBtn;
  var fileInput = ui.fileInput;
  var previewBar = ui.previewBar;
  var replySlotEl = ui.replySlotEl;

  function buildMarketingRuntimeArgs() {
    return {
      messagesEl: messagesEl,
      panelEl: messagesEl && typeof messagesEl.closest === 'function'
        ? messagesEl.closest('.afc')
        : null,
      workerUrl: WORKER_URL,
      apiFetch: apiFetch,
      identity: identity,
      localeContext: localeContext,
      getCustomerIdentity: function () {
        return customerIdentity;
      },
    };
  }

  function runWithWelcomeOptInGate(onContinue) {
    if (
      !marketing ||
      !marketing.shouldPromptAfterFirstUserMessage ||
      !marketing.promptAfterFirstUserMessage
    ) {
      if (typeof onContinue === 'function') onContinue();
      return;
    }

    if (!marketing.shouldPromptAfterFirstUserMessage({
      conversationId: conversationId,
    })) {
      if (typeof onContinue === 'function') onContinue();
      return;
    }

    marketing.promptAfterFirstUserMessage(
      Object.assign({}, buildMarketingRuntimeArgs(), {
        onSubscribed: function () {
          if (identity.rebuild) {
            customerIdentity = identity.rebuild();
          }
        },
        onContinue: onContinue,
      })
    );
  }

  var chatController = controllerApi.create({
    inputEl: inputEl,
    messagesEl: messagesEl,
    media: media,
    analytics: analytics,
    render: render,
    sender: sender,
    identity: identity,
    apiFetch: apiFetch,
    workerUrl: WORKER_URL,
    localeContext: localeContext,
    cidKey: CID_KEY,
    history: history,
    flowerLib: flowerLib,
    resetInputHeight: eventsApi.resetInputHeight,
    setChatTitle: setChatTitle,
    getWelcome: function () { return WELCOME; },
    getConversationId: function () { return conversationId; },
    setConversationId: function (nextId) { conversationId = nextId; },
    getRequesterId: function () { return identity.rebuild().id; },
    getIsLoading: function () { return isLoading; },
    getCustomerIdentity: function () { return customerIdentity; },
    getChatAttribution: function () {
      chatAttribution = captureAttributionBundle();
      return chatAttribution;
    },
    reply: replyApi,
    beforeFirstCustomerAction: runWithWelcomeOptInGate,
  });

  if (marketing && typeof marketing.initTeaser === 'function') {
    marketing.initTeaser(buildMarketingRuntimeArgs());
  }

  if (analytics && analytics.init) {
    analytics.init({ root: root });
  }
  initModules();
  replyApi.init({
    messagesEl: messagesEl,
    replySlotEl: replySlotEl,
    inputEl: inputEl,
    workerUrl: WORKER_URL,
  });
  eventsApi.bind({
    formEl: formEl,
    inputEl: inputEl,
    messagesEl: messagesEl,
    onSubmit: chatController.handleSubmit,
    onToggleHistory: function () { history.toggle(); },
    onToggleFlowerLib: function () { if (flowerLib) flowerLib.toggle(); },
    onNewChat: chatController.handleNewChat,
    onCloseHistory: function () { history.close(); },
    onForgetMe: function () { history.handleForgetMe(); },
  });
  if (analytics && analytics.trackWidgetOpened) {
    analytics.trackWidgetOpened({
      surface: 'landing_page',
      hasExistingConversation: !!conversationId,
    });
  }
  if (analytics && analytics.trackSessionStarted) {
    analytics.trackSessionStarted(!!conversationId);
  }

  var idState = identity.state;
  if (!idState.consentGiven && !idState.consentDeclined) {
    identity.showConsent(document.getElementById('afc-consent-slot'), PRIVACY_URL);
  }

  if (conversationId) {
    history.restoreActive(conversationId).then(function (restored) {
      if (!restored) {
        conversationId = null;
        localStorage.removeItem(CID_KEY);
        showWelcome();
      }
    });
  } else {
    showWelcome();
  }

  // ══════════════════════════════════════════════════════════════════
  // MODULE INITIALISATION
  // ══════════════════════════════════════════════════════════════════

  function initModules() {
    function openOrderFormFlow(source, initialDetails, triggerBackground, allowWhileLoading, selectionRef) {
      if (isLoading && !allowWhileLoading) return;
      if (!conversationId) {
        debug.error('[AI Florist] No active conversation — cannot proceed.');
        render.systemError('Session expired. Please start a new chat.');
        return;
      }

      orderForm.show(initialDetails || null);
      if (triggerBackground) {
        // Phase 1: deterministic product creation in the background.
        // No AI agent — directly calls Shopify API using arrangement
        // data already stored in the DO. If this fails, Phase 2
        // (prepare_checkout) creates the product as a fallback.
        sender.sendBackground(conversationId, selectionRef || null);
      }
    }

    function openWeddingCreativeFlow(initialDetails) {
      if (!conversationId) {
        render.systemError('Session expired. Please start a new chat.');
        return;
      }
      weddingForm.showCreative(initialDetails || null);
    }

    function openWeddingDetailsFlow(initialDetails) {
      if (!conversationId) {
        render.systemError('Session expired. Please start a new chat.');
        return;
      }
      weddingForm.showDetails(initialDetails || null);
    }

    async function handleAddToOrder(selectionRef) {
      var hasCardMessage = !!(selectionRef && selectionRef.cardMessage);
      var hasSelectionImage = !!(selectionRef && selectionRef.imageUrl);
      var hasArrangementName = !!(selectionRef && selectionRef.arrangementName);
      var setProceedState =
        selectionRef && typeof selectionRef.__setProceedState === 'function'
          ? selectionRef.__setProceedState
          : null;
      if (isLoading) {
        if (analytics && analytics.trackAddToOrder) {
          analytics.trackAddToOrder({
            success: false,
            hasCardMessage: hasCardMessage,
            hasSelectionImage: hasSelectionImage,
            hasArrangementName: hasArrangementName,
            reason: 'busy',
          });
        }
        return { success: false, message: 'Please wait for the current request to finish.' };
      }
      if (!conversationId) {
        render.systemError('Session expired. Please start a new chat.');
        if (analytics && analytics.trackAddToOrder) {
          analytics.trackAddToOrder({
            success: false,
            hasCardMessage: hasCardMessage,
            hasSelectionImage: hasSelectionImage,
            hasArrangementName: hasArrangementName,
            reason: 'session_expired',
          });
        }
        return { success: false, message: 'Session expired.' };
      }

      var selected = Object.assign({}, selectionRef || {});
      delete selected.__setProceedState;
      var cardMessage = selected.cardMessage ? String(selected.cardMessage).trim() : '';
      delete selected.cardMessage;
      if (setProceedState) setProceedState('adding');

      var prep = await sender.sendPrepareProduct(conversationId, selected || null, null);
      if (prep && prep.status === 'conflict') {
        prep = await sender.sendPrepareProduct(
          conversationId,
          selected || null,
          { forceRecreate: true }
        );
      }

      if (!prep || (prep.status !== 'created' && prep.status !== 'already_exists')) {
        render.systemError(
          (prep && prep.message) ||
            'Could not prepare this arrangement yet. Please try Add to Order again.'
        );
        if (analytics && analytics.trackAddToOrder) {
          analytics.trackAddToOrder({
            success: false,
            hasCardMessage: hasCardMessage,
            hasSelectionImage: hasSelectionImage,
            hasArrangementName: hasArrangementName,
            reason: 'prepare_failed',
          });
        }
        return { success: false, message: (prep && prep.message) || 'Prepare product failed.' };
      }

      var variantId = Number(prep.variantId);
      if (!variantId) {
        render.systemError('Could not add this arrangement to cart. Please try again.');
        if (analytics && analytics.trackAddToOrder) {
          analytics.trackAddToOrder({
            success: false,
            hasCardMessage: hasCardMessage,
            hasSelectionImage: hasSelectionImage,
            hasArrangementName: hasArrangementName,
            reason: 'missing_variant',
          });
        }
        return { success: false, message: 'Missing variantId in prepare-product response.' };
      }

      var selectionPayload = {
        imageUrl: selected && selected.imageUrl ? selected.imageUrl : (prep.selectionImageUrl || ''),
        arrangementName: selected && selected.arrangementName
          ? selected.arrangementName
          : (prep.arrangementName || ''),
      };
      var addResult = await sender.addPreparedVariantToCart({
        variantId: variantId,
        conversationId: conversationId,
        customer: customerIdentity,
        cardMessage: cardMessage,
        selectionRef: selectionPayload,
        onProgress: function (progress) {
          if (!setProceedState) return;
          if (progress && progress.stage === 'retrying') {
            setProceedState('retrying');
          } else if (progress && progress.stage === 'finalizing') {
            setProceedState('finalizing');
          }
        },
      });

      if (addResult && !addResult.success && addResult.transient) {
        var syncPrep = await sender.sendPrepareProduct(conversationId, selected || null, null);
        if (syncPrep && syncPrep.status === 'conflict') {
          syncPrep = await sender.sendPrepareProduct(
            conversationId,
            selected || null,
            { forceRecreate: true }
          );
        }
        var retryVariantId = Number(syncPrep && syncPrep.variantId) || variantId;
        addResult = await sender.addPreparedVariantToCart({
          variantId: retryVariantId,
          conversationId: conversationId,
          customer: customerIdentity,
          cardMessage: cardMessage,
          selectionRef: {
            imageUrl: selected && selected.imageUrl ? selected.imageUrl : ((syncPrep && syncPrep.selectionImageUrl) || selectionPayload.imageUrl || ''),
            arrangementName: selected && selected.arrangementName
              ? selected.arrangementName
              : ((syncPrep && syncPrep.arrangementName) || selectionPayload.arrangementName || ''),
          },
          onProgress: function (progress) {
            if (!setProceedState) return;
            if (progress && progress.stage === 'retrying') {
              setProceedState('retrying');
            } else if (progress && progress.stage === 'finalizing') {
              setProceedState('finalizing');
            }
          },
        });
      }

      if (!addResult || !addResult.success) {
        if (addResult && addResult.transient) {
          if (analytics && analytics.trackAddToOrder) {
            analytics.trackAddToOrder({
              success: false,
              hasCardMessage: hasCardMessage,
              hasSelectionImage: hasSelectionImage,
              hasArrangementName: hasArrangementName,
              reason: 'cart_add_transient_timeout',
            });
          }
          return {
            success: false,
            message:
              (addResult && addResult.message) ||
              'Still finalizing this arrangement. Please try again in a moment.',
          };
        }
        render.systemError(
          (addResult && addResult.message) ||
            'Could not add this arrangement to cart. Please try again.'
        );
        if (analytics && analytics.trackAddToOrder) {
          analytics.trackAddToOrder({
            success: false,
            hasCardMessage: hasCardMessage,
            hasSelectionImage: hasSelectionImage,
            hasArrangementName: hasArrangementName,
            reason: 'cart_add_failed',
          });
        }
        return {
          success: false,
          message: (addResult && addResult.message) || 'cart/add.js failed',
        };
      }

      if (analytics && analytics.trackAddToOrder) {
        analytics.trackAddToOrder({
          success: true,
          hasCardMessage: hasCardMessage,
          hasSelectionImage: hasSelectionImage,
          hasArrangementName: hasArrangementName,
          itemCount: addResult.itemCount || 0,
        });
      }

      return { success: true, itemCount: addResult.itemCount || 0 };
    }

    render.init({
      messagesEl: messagesEl,
      inputEl: inputEl,
      sendBtn: sendBtn,
      workerUrl: WORKER_URL,
      analytics: analytics,
      addToOrderEnabled: addToOrderEnabled,
      onRetry: function (text) { chatController.sendMessage(text, null, null, null); },
      onProceed: function (selectionRef) {
        if (addToOrderEnabled) {
          return handleAddToOrder(selectionRef || null);
        }
        openOrderFormFlow('proceed_to_order', null, true, false, selectionRef || null);
        return Promise.resolve({ success: true });
      },
      onRegenerate: function () {
        if (isLoading) return;
        if (!conversationId) {
          debug.error('[AI Florist] No active conversation — cannot regenerate.');
          render.systemError('Session expired. Please start a new chat.');
          return;
        }
        if (render.hideStaleCheckoutCards) {
          render.hideStaleCheckoutCards();
        }
        var redesignPrompt = 'I\'d like changes before you redesign it. Please ask what I want to change — form, colours, flowers, or budget.';
        render.message('user', redesignPrompt);
        chatController.sendMessage(
          redesignPrompt,
          null,
          null,
          { expectGeneration: false }
        );
      },
      onRevise: function (opts) {
        if (isLoading) return;
        if (!conversationId) {
          render.systemError('Session expired. Please start a new chat.');
          return;
        }

        var regenerateProduct = !!(opts && opts.regenerateProduct);
        var reviseOrderDetails = !!(opts && opts.reviseOrderDetails);
        if (!regenerateProduct && !reviseOrderDetails) {
          render.systemError('Please select at least one revision option.');
          return;
        }

        sender.sendRevise(conversationId, {
          regenerateProduct: regenerateProduct,
          reviseOrderDetails: reviseOrderDetails,
        }).then(function (result) {
          if (render.hideStaleCheckoutCards) render.hideStaleCheckoutCards();

          if (result && result.assistantMessage) {
            render.message('assistant', result.assistantMessage);
          }

          if (result && result.showOrderForm) {
            openOrderFormFlow('revise', result.deliveryDetails || null, false);
          }
        });
      },
      onDecisionProceed: function () {
        if (isLoading) return Promise.resolve({ success: false, reason: 'busy' });
        if (!conversationId) {
          render.systemError('Session expired. Please start a new chat.');
          return Promise.resolve({ success: false, reason: 'session_expired' });
        }
        var proceedMessage = 'Yes, please proceed with this design.';
        if (analytics && analytics.trackMessageSent) {
          analytics.trackMessageSent({
            interactionSource: 'decision_cta_proceed',
            hasText: true,
            hasImage: false,
            referenceImageCount: 0,
            hasConversationId: !!conversationId,
          });
        }
        render.message('user', proceedMessage);
        render.clearFailedMessage();
        chatController.sendMessage(
          proceedMessage,
          null,
          null,
          { expectGeneration: true }
        );
        return Promise.resolve({ success: true });
      },
      onDecisionRevise: function () {
        if (isLoading) return Promise.resolve({ success: false, reason: 'busy' });
        if (!conversationId) {
          render.systemError('Session expired. Please start a new chat.');
          return Promise.resolve({ success: false, reason: 'session_expired' });
        }
        var reviseMessage = 'I would like to make a few changes before generating.';
        if (analytics && analytics.trackMessageSent) {
          analytics.trackMessageSent({
            interactionSource: 'decision_cta_revise',
            hasText: true,
            hasImage: false,
            referenceImageCount: 0,
            hasConversationId: !!conversationId,
          });
        }
        render.message('user', reviseMessage);
        render.clearFailedMessage();
        chatController.sendMessage(reviseMessage, null, null, { expectGeneration: false });
        return Promise.resolve({ success: true });
      },
      onWelcomeReferenceCta: function () {
        if (media && typeof media.openFilePicker === 'function') {
          media.openFilePicker({ fromWelcome: true });
        }
      },
      onOpenWeddingCreative: function (prefill) {
        openWeddingCreativeFlow(prefill || null);
      },
      onOpenWeddingDetails: function (prefill) {
        openWeddingDetailsFlow(prefill || null);
      },
      onWeddingConceptRegenerate: function () {
        if (isLoading) return;
        if (!conversationId) {
          render.systemError('Session expired. Please start a new chat.');
          return;
        }
        var regenerateMessage = 'Please help me tweak the wedding concepts.';
        if (analytics && analytics.trackMessageSent) {
          analytics.trackMessageSent({
            interactionSource: 'wedding_concept_regenerate',
            hasText: true,
            hasImage: false,
            referenceImageCount: 0,
            hasConversationId: !!conversationId,
          });
        }
        render.message('user', regenerateMessage);
        render.clearFailedMessage();
        chatController.sendMessage(regenerateMessage);
      },
      onWelcomeReferenceClear: function () {
        if (media && typeof media.clearPendingImage === 'function') {
          media.clearPendingImage();
        }
      },
      onWelcomeReferenceRemove: function (index) {
        if (media && typeof media.removePendingImageByIndex === 'function') {
          media.removePendingImageByIndex(index);
        }
      },
    });

    history.init({
      workerUrl: WORKER_URL,
      drawerEl: document.getElementById('afc-drawer'),
      drawerOverlayEl: document.getElementById('afc-drawer-overlay'),
      drawerListEl: document.getElementById('afc-drawer-list'),
      historyBtnEl: document.getElementById('afc-history-btn'),
      onConversationLoaded: function (newId, title) {
        conversationId = newId;
        if (newId) localStorage.setItem(CID_KEY, newId);
        setChatTitle(title);
      },
      onForgetComplete: function () {
        conversationId = null;
        customerIdentity = identity.rebuild();
        setChatTitle(null);
        render.clearMessages();
        render.message('assistant', WELCOME, null, null, null, null, { welcomeCta: true });
        identity.showConsent(
          document.getElementById('afc-consent-slot'),
          PRIVACY_URL
        );
      },
    });

    media.init({
      render: render,
      workerUrl: WORKER_URL,
      inputEl: inputEl,
      fileInput: fileInput,
      previewBar: previewBar,
      previewThumbsEl: document.getElementById('afc-preview-thumbs'),
      multiPreviewEl: document.getElementById('afc-preview-multi'),
      maxImageDim: 1536,
      maxBase64Length: 5600000,
      isBusy: function () { return isLoading; },
      onLibrarySelectionSync: function (items) {
        if (flowerLib && flowerLib.setSelected) {
          flowerLib.setSelected(items, true);
        }
      },
    });

    media.bind({
      uploadBtn: uploadBtn,
    });

    if (autosuggest) {
      autosuggest.init({
        workerUrl: WORKER_URL,
        inputEl: inputEl,
        suggestLib: AF.suggestLib || null,
      });
    }

    if (flowerLib) {
      flowerLib.init({
        workerUrl: WORKER_URL,
        onSelectionChange: function (items) {
          media.setLibrarySelections(items);
        },
      });
    }

    sender.init({
      workerUrl: WORKER_URL,
      apiFetch: apiFetch,
      stream: stream,
      render: render,
      analytics: analytics,
      setChatTitle: setChatTitle,
      onConversationId: function (newId) {
        conversationId = newId;
        if (newId) localStorage.setItem(CID_KEY, newId);
      },
      onBusyChange: function (busy) {
        isLoading = busy;
      },
      onSessionExpired: function () {
        debug.warn('[AI Florist] Session expired — clearing stale conversationId.');
        conversationId = null;
        localStorage.removeItem(CID_KEY);
        if (window.AIFlorist && window.AIFlorist.send && window.AIFlorist.send.setConversationState) {
          window.AIFlorist.send.setConversationState(null);
        }
        render.systemError('Your chat session has expired.', {
          actionLabel: 'Start New Chat',
          onAction: function () {
            setChatTitle(null);
            render.clearMessages();
            render.message('assistant', WELCOME, null, null, null, null, { welcomeCta: true });
            media.clearAll();
            if (flowerLib) flowerLib.clearSelected();
          },
        });
      },
      onGenerationStart: function () {
        // Keep references sticky during conversation, but clear once generation begins.
        media.clearLibrarySelections();
      },
      getRequesterId: function () {
        return identity.rebuild().id;
      },
      triggerMarketingPrompt: function (onContinue) {
        if (!marketing || !marketing.promptAfterFirstUserMessage) {
          if (typeof onContinue === 'function') onContinue();
          return;
        }
        marketing.promptAfterFirstUserMessage(
          Object.assign({}, buildMarketingRuntimeArgs(), {
            onSubscribed: function () {
              if (identity.rebuild) {
                customerIdentity = identity.rebuild();
              }
            },
            onContinue: onContinue,
          })
        );
      },
      onProceedToOrder: function (initialDetails) {
        // In Add-to-Order mode, checkout is completed from cart page.
        if (addToOrderEnabled) {
          window.location.href = '/cart';
          return;
        }
        // Metadata-triggered proceed can arrive before onDone clears isLoading.
        // Allow this path to open the form immediately in the same turn.
        openOrderFormFlow('chat_intent', initialDetails || null, true, true);
      },
      onOpenWeddingCreative: function (initialDetails) {
        openWeddingCreativeFlow(initialDetails || null);
      },
      onOpenWeddingDetails: function (initialDetails) {
        openWeddingDetailsFlow(initialDetails || null);
      },
    });

    orderForm.init({
      messagesEl: messagesEl,
      onConfirm: function (composedMessage, deliveryDetails) {
        if (analytics && analytics.trackMessageSent) {
          analytics.trackMessageSent({
            interactionSource: 'order_form_confirm',
            hasText: true,
            hasImage: false,
            referenceImageCount: 0,
            hasConversationId: !!conversationId,
          });
        }
        render.message('user', composedMessage);
        render.clearFailedMessage();

        // Deterministic checkout: save delivery details + create cart
        // in the DO before sending to Fleur. By the time Fleur processes
        // the message, the checkout URL is already stored in DO state.
        if (conversationId && deliveryDetails) {
          if (checkoutMode === 'drawer') {
            sender.sendPrepareProduct(conversationId, null).then(function (prepResult) {
              var handoffPayload = {
                variantId: prepResult && prepResult.variantId,
              };
              sender.handoffToCartDrawer(handoffPayload, deliveryDetails, conversationId, chatAttribution);
            });
            return;
          }
          sender.sendCheckout(conversationId, deliveryDetails, chatAttribution).then(function () {
            chatController.sendMessage(composedMessage);
          });
        } else {
          chatController.sendMessage(composedMessage);
        }
      },
    });

    weddingForm.init({
      messagesEl: messagesEl,
      render: render,
      submitWeddingCreativeBrief: async function (payload, summaryText) {
        return await new Promise(function (resolve) {
          runWithWelcomeOptInGate(async function () {
            if (!conversationId) {
              resolve({
                success: false,
                assistantMessage: 'Session expired. Please start a new chat.',
              });
              return;
            }

            render.showDesigningCard();

            try {
              var res = await apiFetch(
                WORKER_URL + '/conversation/' + encodeURIComponent(conversationId) + '/wedding-brief/creative',
                {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ brief: payload }),
                }
              );
              var data = await res.json();

              if (!res.ok) {
                resolve({
                  success: false,
                  errors: data && data.errors ? data.errors : {},
                  assistantMessage:
                    (data && data.assistantMessage) ||
                    'A few wedding brief details still need attention before I can generate the concepts.',
                });
                return;
              }

              render.message('user', summaryText || "I've submitted my wedding creative brief.");
              render.clearFailedMessage();
              render.message('assistant', data.assistantMessage || '', data.metadata || null);
              resolve({ success: true });
            } finally {
              render.removeIndicators();
            }
          });
        });
      },
      submitWeddingDetails: async function (payload, summaryText) {
        return await new Promise(function (resolve) {
          runWithWelcomeOptInGate(async function () {
            if (!conversationId) {
              resolve({
                success: false,
                assistantMessage: 'Session expired. Please start a new chat.',
              });
              return;
            }

            var res = await apiFetch(
              WORKER_URL + '/conversation/' + encodeURIComponent(conversationId) + '/wedding-brief/details',
              {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ details: payload }),
              }
            );
            var data = await res.json();

            if (!res.ok) {
              resolve({
                success: false,
                errors: data && data.errors ? data.errors : {},
                assistantMessage:
                  (data && data.assistantMessage) ||
                  'A few wedding details still need attention before I can save the project.',
              });
              return;
            }

            render.message('user', summaryText || "I've submitted my wedding details.");
            render.clearFailedMessage();
            render.message('assistant', data.assistantMessage || '', data.metadata || null);
            resolve({ success: true });
          });
        });
      },
    });
  }

  function captureAttributionBundle() {
    var merged = {};
    try {
      merged = attributionApi.capture ? (attributionApi.capture() || {}) : {};
    } catch (_err) {
      merged = {};
    }
    try {
      if (attributionApi.captureFirstTouch) {
        merged.firstTouchAttribution = attributionApi.captureFirstTouch() || null;
      }
      if (attributionApi.captureLastTouch) {
        merged.lastTouchAttribution = attributionApi.captureLastTouch() || null;
      }
    } catch (_err2) {
      // ignore attribution helper failures
    }
    return merged;
  }

  // ══════════════════════════════════════════════════════════════════
  // WELCOME & TITLE HELPERS
  // ══════════════════════════════════════════════════════════════════

  function showWelcome() {
    fetchWelcomeCopy()
      .catch(function () { return null; })
      .finally(function () {
        render.message('assistant', WELCOME, null, null, null, null, { welcomeCta: true });
      });
  }

  async function fetchWelcomeCopy() {
    if (!WORKER_URL) return;
    var query = new URLSearchParams({
      locale: localeContext.locale || '',
      language: localeContext.language || '',
    });
    var res = await apiFetch(WORKER_URL + '/welcome?' + query.toString(), { method: 'GET' });
    if (!res.ok) return;
    var data = await res.json();
    if (data && typeof data.welcomeMessage === 'string' && data.welcomeMessage.trim()) {
      WELCOME = data.welcomeMessage;
    }
    if (data && data.pusher && sender.setPusherConfig) {
      sender.setPusherConfig(data.pusher);
    }
    if (data && data.deliveryConfig && orderForm.setDeliveryConfig) {
      orderForm.setDeliveryConfig(data.deliveryConfig);
    }
  }

  function setChatTitle(title) {
    if (titleEl) {
      titleEl.textContent = title || DEFAULT_TITLE;
    }
  }
})();
